import { REVIEW_TYPES_REQUESTED } from '../../../libs/Constants';

const validOptions = [
  'Peer-To-Peer Scheduled',
  'Peer-To-Peer Scheduled By PA',
  'PA to Schedule Peer-To-Peer',
];

export const shouldShowIndicator = (row) => {
  const showIndicator =
    (row.review_type_requested === REVIEW_TYPES_REQUESTED.P2P &&
      validOptions.includes(row.schedule_option_selected)) ||
    (row.review_type_requested ===
      REVIEW_TYPES_REQUESTED.STATUS_DETERMINATION &&
      validOptions.includes(row.schedule_option_selected)) ||
    (row.review_type_requested === REVIEW_TYPES_REQUESTED.MANUAL &&
      validOptions.includes(row.schedule_option_selected)) ||
    (row.review_type_requested ===
      REVIEW_TYPES_REQUESTED.APPEAL_RETROSPECTIVE &&
      validOptions.includes(row.schedule_option_selected));
  return showIndicator;
};
